module.exports = __webpack_public_path__ + "static/b148572207607bbb291106f36860bfa156abc8d8502e49bf6efd789537024c51-89e461eecc15e6fefa158bc9d5a0fb4f.png";